import BaseObject from '../../../base/base_object';
import LastLoginComponentController from "../../../components/regulation_components/base/last_login/last_login_component_controller";
import {TimeSpan} from "@sparkware/app-utils";
import SessionTimerLogicHelper from "../helpers/session_timer_logic_helper";
import {CLOCK_LOCALIZATION} from "../../clock/clock_service_consts";
import ServiceFactory from '../../service_factory';
import GenericRealityCheckMessageHandler from '../helpers/generic_reality_check_message_handler';
import {GNWP_SOURCES} from "../../../components/external_links/external_links_consts";
import BaseComponent from '../../../base/base_component';

export interface BaseRegulationParams {
    serviceFactory: ServiceFactory,
    cssSuffix: string,
    realityCheckInterval: string
}

export default class BaseRegulation extends BaseObject{

    static CLASS = 'BaseRegulation';

    protected init(params: BaseRegulationParams) {
        super.init(params);
        this.serviceFactory = params.serviceFactory;
        this.cssSuffix = params.cssSuffix;
        this._realityCheckInterval = this._parseRealityCheckInterval(params.realityCheckInterval);
    }

    protected serviceFactory: ServiceFactory;
    private cssSuffix: string;
    private _sessionTimerHandler: SessionTimerLogicHelper = null;
    private _realityCheckMessageHandler: GenericRealityCheckMessageHandler = null;

    private _parseRealityCheckInterval(interval) {
        let defaultValue = TimeSpan.fromHours(1);
        if(!interval) {
            return defaultValue;
        }
        try {
            let timeSpan = TimeSpan.parse(interval);
            timeSpan = new TimeSpan(timeSpan.days, timeSpan.hours, timeSpan.minutes, 0, 0);
            if (timeSpan.totalMinutes < 1) {
                return TimeSpan.fromMinutes(1);
            }

            return timeSpan;
        }
        catch (err) {
            this.logger.error('Failed to parse RealityCheckInterval ' + interval);
            return defaultValue;
        }
    }

    private _realityCheckInterval: TimeSpan;
    getRealityCheckInterval(): TimeSpan {
        if(this.realityCheckEnabled()) {
            return this._realityCheckInterval;
        } else {
            return TimeSpan.fromMilliseconds(0);
        }
    }

    updateRealityCheckInterval(realityCheckIntevalMin: number): Promise<void> {
        /**
         * Normally, the user cannot modify or update the reality check interval
         * This method is implemented in Malta and UK Regulations, regulations that allow the user to set a desired interval
         */
        return Promise.resolve();
    }

    hybridNyxClosedButtonEnabled(){
        return false;
    }


    forceHideCloseButtonInMembership() {
        return false;
    }

    getRealityCheckIntervalExpectedByTheGame() {
        let interval = this.getRealityCheckInterval();
        return {
            timeSpan: interval,
            expectedValueByTheGame: Math.round(interval.totalMinutes)
        }
    }

    dispose() {
        if (this._realityCheckMessageHandler) {
            this._realityCheckMessageHandler.dispose();
        }

        if (this._sessionTimerHandler) {
            this._sessionTimerHandler.dispose();
        }
    }

    protected _handleRealityCheckMessage(sessionTimer: TimeSpan): void {

    }

    showSessionBalanceInAboutBox(): boolean {
        return false;
    }

    showTempAccountMessage(closeFunc?: Function): void {
    }

    protected sessionTimerEnabled(): boolean {
        return false;
    }

    sessionTimerVisible(): boolean {
        return false;
    }

    protected realityCheckEnabled(): boolean {
        return false;
    }

    showResponsibleIcons(): boolean {
        return false;
    }

    showAgeResponsibleGameInDetailedHistory(): boolean {
        return false;
    }

    showAgeResponsibleIconInGame(): boolean {
        return true;
    }

    getCurrentSessionTime(): TimeSpan {
        if (this._sessionTimerHandler) {
            return this._sessionTimerHandler.getSessionTime();
        }
        return TimeSpan.fromMinutes(0);
    }


    getCssSuffix(): string {
        return this.cssSuffix;
    }

    startSessionTimer(): void {
        if (this.sessionTimerEnabled()) {

            if(!this._sessionTimerHandler) {
                this._sessionTimerHandler = SessionTimerLogicHelper.create();
            }

            if(this._realityCheckMessageHandler) {
                this._realityCheckMessageHandler.dispose();
            }

            this._realityCheckMessageHandler = GenericRealityCheckMessageHandler.create({
                    serviceFactory: this.serviceFactory,
                    realityCheckInterval: this.getRealityCheckInterval(),
                    handleRealityCheckMessageCallback: this._handleRealityCheckMessage.bind(this)
            });


            this._sessionTimerHandler.start();
        }
    }


    stopSessionTimer(): void {
        if(this._realityCheckMessageHandler) {
            this._realityCheckMessageHandler.dispose();
        }

        if(this._sessionTimerHandler) {
            this._sessionTimerHandler.dispose();
            this._sessionTimerHandler = null;
        }
    }

    //TO DO - we should change the type to BaseComponent when BaseComponent will be converted to TypeScript
    getLastLoginComponent(params) {
        return LastLoginComponentController.create(params);
    }

    onKickEvent(kickParams): void {

    }

    openSelfTest(view) {

    }

    openLimits(): void {

    }

    openSelfExclusion(view): void {

    }


    /**
     * Get specific external link configuration that should override the default defined in external_link_consts
     */
    getExternalLinksConfig(): any {}

    showLoginMessage(): void {}

    showLogoutMessage(): void {}

    getClockLocalization(): string {
        return CLOCK_LOCALIZATION.LOCAL;
    }

    getResponsibleGamingIconsComponent(params: any): BaseComponent {
        return null;
    }

    getErrorMessage(errorCode: number): string {
        return this.serviceFactory.languageService().translation(errorCode.toString());
    }

    isAnonymousPlayAllowed(): boolean {
        return true;
    }

    forceDemoButton(): boolean {
        return false;
    }

    forceIntermediatePageForAutorizedUsers(): boolean {
        return true;
    }

    supportWithdrawOnlyFromReal(): boolean {
        return true;
    }

    shouldPreventMoreThanOneOpenGame(): boolean {
        return true;
    }

    getTempAccountGnwpSource() {
        return GNWP_SOURCES.CASHIER;
    }

    shouldHaveBetLimitsPerBrand(): boolean {
        return false;
    }

    async showGamePopup(): Promise<void> {

    }

    isGamePopupStepPass() {
        return true;
    }

    showHelpInAboutWindow() {
        return true;
    }

    isSessionCooldownEnabled(): boolean {
        return false;
    }

    showNetPosition(): boolean {
        return false;
    }

    overrideCurrencySymbol(): null | string {
        return null;
    }

    shouldShowPlayerLimitsToaster(): boolean {
        return false;
    }

    checkIfCorrectAppInUse(country:string, state: string) {

    }

    shouldCallCountryByIP(country:string) {
        return false;
    }

    runConditionsBeforeOpenLink(source: string):Promise<void> {
        return Promise.resolve();
    }

    fitToPlayModeEnabled(): boolean {
        return false;
    }

    stepsBeforeOpenLoginAndRegistration():Promise<void> {
        return Promise.resolve();
    }

    getAgeResponsibleGamingLabel(): string | null {
        return null;
    }

    shouldRefreshTokenOnAppOpen() {
        return true;
    }

    showNightLimitMessage(nightLimitExpirationDate: Date) {

    }
}